import { useOptions } from '../page-framework/panel/Panel';
import { useDashboardContext } from '../page-framework';
import SiteMap from './SiteMap';

export default function SiteMapPanel(props) {
    const [options, setOptions] = useOptions();
    const { editing, saving } = useDashboardContext();

    return <SiteMap options={options} onOptionsChange={setOptions} editing={editing} saving={saving} {...props} />;
}
